/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Banner_Default_MessageInputs */



/**
* | output |
* | --- |
* | "We're currently experiencing high load. Document processing may be slower than usual. We're working on resolving this." |
*
* @param {Status_Banner_Default_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_banner_default_message = /** @type {((inputs?: Status_Banner_Default_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Banner_Default_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir verzeichnen derzeit eine hohe Auslastung. Die Dokumentenverarbeitung kann langsamer als gewöhnlich sein. Wir arbeiten an einer Lösung.")
	return /** @type {LocalizedString} */ ("We're currently experiencing high load. Document processing may be slower than usual. We're working on resolving this.")
});